import React from "react";
import { Player } from "@lottiefiles/react-lottie-player";

const ConfettiResult = () => {
  return (
    <div>
      <Player
        autoplay
        src="https://lottie.host/43b5714e-5947-4c52-a855-0d9dd0cd06a9/1SaMnPdxvh.json"
        style={{ height: "615px", width: "365px", position: "absolute" }}
      ></Player>
    </div>
  );
};

export default ConfettiResult;
